import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { CoordinateInformation } from 'types/shared';

interface CoordinateInfoProps {
  coordinateInformation: CoordinateInformation;
  dataTestId?: string;
}

export const CoordinateInfo = ({ coordinateInformation, dataTestId }: CoordinateInfoProps) => {
  const { icon, overnightMessage, subtitle, title } = coordinateInformation;

  return (
    <UitkLayoutFlex direction="column" dataTestId={dataTestId}>
      <UitkLayoutFlexItem>
        <UitkHeading level={4} size={300}>
          <UitkIcon name={icon.id} size={UitkIconSize.SMALL} className="all-r-padding-two uitk-type-paragraph-300" />
          <UitkText size={300} inline={true}>
            {title}
          </UitkText>
        </UitkHeading>
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem className="all-t-margin-half">
        <span>
          <UitkSubheading>
            <UitkText size={300} inline={true} className="all-l-padding-six">
              {subtitle}
            </UitkText>
          </UitkSubheading>
        </span>
      </UitkLayoutFlexItem>
      {overnightMessage && (
        <UitkLayoutFlexItem>
          <UitkText size={300} spacing="one" theme="negative" className="all-l-padding-six">
            {overnightMessage}
          </UitkText>
        </UitkLayoutFlexItem>
      )}
    </UitkLayoutFlex>
  );
};
